export default "__VITE_ASSET__r0TSHG9Q__"